module.exports = __webpack_public_path__ + "static/media/500.d1582414.svg";